import { configureStore } from '@reduxjs/toolkit';

import navReducer from 'components/Navigation/slice';
import mastheadReducer from 'components/Masthead/slice';
import bodyReducer from './bodySlice';
import { conditionsApi } from './conditionsSlice';
import { flagApi } from './flagSlice';
import chatReducer from 'components/Chat/slice';

export default configureStore({
	reducer: {
		nav: navReducer,
		masthead: mastheadReducer,
		body: bodyReducer,
		[conditionsApi.reducerPath]: conditionsApi.reducer,
		[flagApi.reducerPath]: flagApi.reducer,
		chat: chatReducer,
	},

	middleware: (getDefaultMiddleware) => {
		let middlewares;
		middlewares = getDefaultMiddleware().concat(conditionsApi.middleware).concat(flagApi.middleware);
		return middlewares;
	},
});